/* Ramah card personalizer: live preview, pricing and add-to-cart.
   Adds the pack (with its personalization) and, for "Send in Signatures", one
   "Printed signature" line per pack, then goes to the cart. */
(function () {
  "use strict";

  var MIN_SCALE = 0.6;          // smallest we'll shrink text to fit the card
  var SMALL_SCALE = 0.86;       // below this, tell the customer we'll set it smaller
  var MAX_FILE_MB = 15;
  var FONTS = ["ff-classic", "ff-script", "ff-modern"];

  /* ---------- standard message and scripture layouts ----------
     Each standard message and scripture is printed from a template (Google
     Drive › Product Custom Options › Messages / Scriptures) with its own line
     breaks. The snippet lists them as plain text; see "HOW EACH STANDARD
     MESSAGE IS LAID OUT" and "HOW EACH SCRIPTURE IS LAID OUT" in
     snippets/ramah-personalizer.liquid for the format. After "//" comes a
     message's closing line or a scripture's reference. */
  var TPL_DEFAULTS = { cs: 1.15, lh: 1.35, gap: 2.25 };
  var SCR_DEFAULTS = { cs: 1.05, lh: 1.4, gap: 1.5 };
  function normText(t) {
    return String(t || "").replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/[–—]/g, "-")
      .replace(/\s+/g, " ").trim().toLowerCase();
  }
  function parseSpec(s, defaults) {
    var opts = s.split("|");
    var body = opts.shift().split("//");
    var spec = {
      lines: body[0].split("/").map(function (l) { return l.trim(); }).filter(function (l) { return !!l; }),
      close: (body[1] || "").trim(),
      cs: defaults.cs, lh: defaults.lh, gap: defaults.gap, align: "center"
    };
    opts.forEach(function (o) {
      var kv = o.trim().split(/\s+/), v = parseFloat(kv[1]);
      if (kv[0] === "align") { if (kv[1] === "left") spec.align = "left"; return; }
      if (isNaN(v) || v <= 0) return;
      if (kv[0] === "close" || kv[0] === "ref") spec.cs = v;
      else if (kv[0] === "spacing") spec.lh = v;
      else if (kv[0] === "gap") spec.gap = v;
    });
    return spec.lines.length ? spec : null;
  }
  function parseLayouts(txt, defaults) {
    var map = {}, cur = null;
    String(txt || "").split(/\r?\n/).forEach(function (raw) {
      var line = raw.trim();
      if (!line) { cur = null; return; }
      if (line.charAt(0) === "#") return;
      var m = line.match(/^(wide|book)\s*:\s*(.*)$/i);
      if (m) {
        if (cur) cur[m[1].toLowerCase() === "wide" ? "horizontal" : "vertical"] = parseSpec(m[2], defaults);
        return;
      }
      cur = map[normText(line)] = {};
    });
    return map;
  }

  function money(cents) {
    return "$" + (Math.round(cents) / 100).toFixed(2);
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function init(root) {
    if (root.__rpReady) return;
    root.__rpReady = true;

    var cfgEl = root.querySelector("[data-rp-config]");
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return root.querySelectorAll(s); };

    var form = q("[data-rp-form]");
    var preview = q("[data-rp-preview]");
    var stage = q("[data-rp-stage]");
    var card = q("[data-rp-card]");
    var zoneScr = q("[data-rp-zone-scr]");
    var zoneMsg = q("[data-rp-zone-msg]");
    var stack = q("[data-rp-stack]");
    var pvScr = q("[data-rp-pv-scr]");
    var pvScrText = q("[data-rp-pv-scrtext]");
    var pvRef = q("[data-rp-pv-ref]");
    var pvMsg = q("[data-rp-pv-msg]");
    var pvOwn = q("[data-rp-pv-own]");
    var pvNames = q("[data-rp-pv-names]");
    var pvSig = q("[data-rp-pv-sig]");
    var pvSigPh = q("[data-rp-pv-sigph]");
    var pvSigWrap = q("[data-rp-pv-sigwrap]");
    var namesTip = q("[data-rp-names-tip]");
    var spaceNote = q("[data-rp-spacenote]");
    var hint = q("[data-rp-hint]");
    var fitNote = q("[data-rp-fitnote]");
    var zoomBtn = q("[data-rp-zoom]");
    var zoomClose = q("[data-rp-zoom-close]");
    var scrSel = q("[data-rp-scripture]");
    var msgSel = q("[data-rp-message]");
    var msgOpt = q("[data-rp-msgopt]");
    var msg = q("[data-rp-msg]");
    var names = q("[data-rp-names]");
    var extra = q("[data-rp-extra]");
    var extraNote = q("[data-rp-extranote]");
    var count = q("[data-rp-count]");
    var sigField = q("[data-rp-sigfield]");
    var sigInput = q("[data-rp-sig]");
    var fileName = q("[data-rp-filename]");
    var qty = q("[data-rp-qty]");
    var cards = q("[data-rp-cards]");
    var bulk = q("[data-rp-bulk]");
    var confirm = q("[data-rp-confirm]");
    var errorBox = q("[data-rp-error]");
    var submit = q("[data-rp-submit]");
    var pill = q("[data-rp-pill]");
    var scrTip = q("[data-rp-scr-tip]");
    var ruleFont = q('[data-rp-rule="font"]');
    var ruleLayout = q('[data-rp-rule="layout"]');
    var extraPlaceholder = extra ? extra.getAttribute("placeholder") || "" : "";
    var layoutsEl = q("[data-rp-layouts]");
    var LAYOUTS = parseLayouts(layoutsEl ? layoutsEl.textContent : "", TPL_DEFAULTS);
    var scrLayoutsEl = q("[data-rp-scr-layouts]");
    var SCR_LAYOUTS = parseLayouts(scrLayoutsEl ? scrLayoutsEl.textContent : "", SCR_DEFAULTS);

    var state = { overflow: false, touched: false, cardVisible: true, formVisible: false, ctaVisible: false, namesFontPicked: false };

    /* ---------- helpers ---------- */
    function isSigned() {
      var c = root.querySelector("[data-rp-choice]:checked");
      return !!(c && c.getAttribute("data-rp-choice") === "signed");
    }
    // Message is a list of radio buttons showing each message in full.
    function pickedMsg() {
      var r = msgSel && msgSel.querySelector("input:checked");
      return r ? (r.getAttribute("data-text") || "") : "";
    }
    // "A scripture of your choice": the customer tells us which one in their notes.
    function ownScr() {
      if (!scrSel || scrSel.selectedIndex < 0) return false;
      return scrSel.options[scrSel.selectedIndex].hasAttribute("data-rp-own-scr");
    }
    function scrChosen() { return !!picked(scrSel).text || ownScr(); }
    function picked(sel) {
      if (!sel || sel.selectedIndex < 0) return { text: "", ref: "" };
      var o = sel.options[sel.selectedIndex];
      return { text: o.getAttribute("data-text") || "", ref: o.getAttribute("data-ref") || "" };
    }
    function lettering(group) {
      var el = root.querySelector('[data-rp-ff="' + group + '"]:checked');
      return "ff-" + (el ? el.getAttribute("data-ff") : (group === "names" ? "script" : "modern"));
    }
    function setLettering(el, cls) {
      FONTS.forEach(function (f) { el.classList.remove(f); });
      el.classList.add(cls);
    }
    function packs() {
      var n = parseInt(qty.value, 10);
      return isNaN(n) || n < 1 ? 1 : Math.min(n, 999);
    }
    function hasFile() { return !!(sigInput && sigInput.files && sigInput.files.length); }
    function syncOn(selector) {
      each(qa(selector), function (input) {
        var label = input.closest("label");
        if (label) label.classList.toggle("is-on", input.checked);
      });
    }
    function clearError() {
      errorBox.hidden = true;
      errorBox.textContent = "";
      each(qa(".is-missing"), function (el) { el.classList.remove("is-missing"); });
    }
    function showError(text, focusEl) {
      errorBox.textContent = text;
      errorBox.hidden = false;
      if (focusEl) {
        var holder = focusEl.closest(".rp-check, .rp-file, .rp-part, .rp-fs") || focusEl;
        holder.classList.add("is-missing");
        holder.scrollIntoView({ behavior: "smooth", block: "center" });
        try { focusEl.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
      }
    }

    /* ---------- names ---------- */
    // Keep each person's name in one piece on the card. A new line in the box
    // starts a new line on the card; commas, semicolons and "and"/"&" are the
    // only places a line may wrap. Long phrases still wrap normally.
    var NAME_WORDS = 5, NAME_CHARS = 34;
    function shortEnough(t) {
      return t.split(" ").length <= NAME_WORDS && t.length <= NAME_CHARS;
    }
    function namePieces(chunk) {
      if (shortEnough(chunk)) return [[chunk, true]];
      var parts = chunk.split(/\s+(?=(?:and|&)\s)/i);
      if (parts.length < 2) return [[chunk, false]];
      return parts.map(function (p) { return [p, shortEnough(p)]; });
    }
    function nameLines(text) {
      return text.split(/\r?\n/).map(function (raw) { return raw.replace(/\s+/g, " ").trim(); })
        .filter(function (line) { return !!line; });
    }
    function fillNameLine(row, line) {
      var bits = line.split(/\s*([,;])\s*/);
      for (var i = 0; i < bits.length; i += 2) {
        var body = bits[i].trim();
        var sep = bits[i + 1] || "";
        if (!body && !sep) continue;
        namePieces(body).forEach(function (piece, j, all) {
          var t = piece[0] + (j === all.length - 1 ? sep : "");
          if (row.childNodes.length) row.appendChild(document.createTextNode(" "));
          if (piece[1]) {
            var s = document.createElement("span");
            s.className = "rp-nw";
            s.textContent = t;
            row.appendChild(s);
          } else {
            row.appendChild(document.createTextNode(t));
          }
        });
      }
      return row;
    }
    function clear(el) { while (el.firstChild) el.removeChild(el.firstChild); }
    function el(tag, cls) { var e = document.createElement(tag); e.className = cls; return e; }

    // List Layout: one line per line typed.
    function renderNames(box, text) {
      clear(box);
      nameLines(text).forEach(function (line) {
        box.appendChild(fillNameLine(el("span", "rp-names__line"), line));
      });
    }

    // Send in Signatures, List Layout: each person's signature prints on
    // a dotted line just above their name.
    function renderSignedNames(box, text, opts) {
      clear(box);
      var lines = nameLines(text);
      lines.forEach(function (line) {
        var person = el("div", "rp-signee");
        var slot = el("div", "rp-sigline" + (opts.set ? " is-set" : ""));
        if (opts.img && lines.length === 1) {
          var im = el("img", "rp-sigline__img");
          im.src = opts.img;
          im.alt = "Your signature as it will print";
          slot.appendChild(im);
          slot.classList.add("has-img");
        } else {
          var label = el("span", "rp-sigline__label");
          label.textContent = "Your signature prints here";
          slot.appendChild(label);
        }
        person.appendChild(slot);
        person.appendChild(fillNameLine(el("span", "rp-names__line"), line));
        box.appendChild(person);
      });
      return lines.length;
    }

    // Tree Layout: a space above every name, laid out like your sample cards.
    // An odd count puts the first person alone on top (the bishop), then pairs.
    function renderSignBlocks(box, text, opts) {
      clear(box);
      var lines = nameLines(text);
      var rows = [], i = 0;
      if (lines.length % 2 === 1) { rows.push([0]); i = 1; }
      for (; i < lines.length; i += 2) rows.push(i + 1 < lines.length ? [i, i + 1] : [i]);
      rows.forEach(function (idxs) {
        var row = el("div", "rp-signrow" + (idxs.length === 1 ? " rp-signrow--one" : ""));
        idxs.forEach(function (j) {
          var block = el("div", "rp-signblock");
          var space = el("div", "rp-signspace" + (opts.set ? " is-set" : ""));
          if (opts.img && lines.length === 1) {
            var im = el("img", "rp-signspace__img");
            im.src = opts.img;
            im.alt = "Your signature as it will print";
            space.appendChild(im);
            space.classList.add("has-img");
          } else if (opts.signed) {
            // Hand-Signed cards get an empty box: the space they sign in by hand.
            var label = el("span", "rp-signspace__label");
            label.textContent = lines.length === 1 ? "Your signature" : "Signature " + (j + 1);
            space.appendChild(label);
          }
          block.appendChild(space);
          block.appendChild(fillNameLine(el("div", "rp-signname"), lines[j]));
          row.appendChild(block);
        });
        box.appendChild(row);
      });
      return lines.length;
    }
    function namesLayout() {
      var r = root.querySelector("[data-rp-nlayout]:checked");
      return r ? r.getAttribute("data-rp-nlayout") : "together";
    }

    /* ---------- preview ---------- */
    // A standard message with a template prints line for line as the template.
    // The templates' closing lines are left off so the customer signs off in
    // their own words (a closing line still shows if the layouts list one).
    // Anything else wraps.
    function pickLayout(map, key) {
      var entry = key ? map[normText(key)] : null;
      return entry ? entry[cfg.layout === "vertical" ? "vertical" : "horizontal"] || null : null;
    }
    function stdLayout(std) { return pickLayout(LAYOUTS, std); }
    // Lines of a template, then (if any) its closing line or reference.
    function fillTemplate(box, spec, lastClass) {
      clear(box);
      box.style.setProperty("--tpl-lh", String(spec.lh));
      box.style.setProperty("--tpl-cs", String(spec.cs));
      box.style.setProperty("--tpl-gap", String(spec.gap));
      spec.lines.forEach(function (t) {
        var line = el("span", "rp-tl");
        line.textContent = t;
        box.appendChild(line);
      });
      if (spec.close) {
        var last = el("span", "rp-tl rp-tl--close" + (lastClass ? " " + lastClass : ""));
        last.textContent = spec.close;
        box.appendChild(last);
      }
    }
    function renderStdMsg(std) {
      var spec = stdLayout(std);
      clear(pvMsg);
      pvMsg.classList.toggle("is-template", !!spec);
      if (!spec) { pvMsg.textContent = std; return; }
      fillTemplate(pvMsg, spec, "");
    }
    // A listed scripture with a template prints line for line as the template,
    // its reference right-aligned underneath. "A scripture of your choice"
    // shows a faint stand-in instead.
    function renderScripture(scr, own) {
      var spec = own ? null : pickLayout(SCR_LAYOUTS, scr.ref);
      pvScrText.classList.toggle("is-template", !!spec);
      pvScrText.classList.toggle("is-left", !!spec && spec.align === "left");
      if (spec) {
        fillTemplate(pvScrText, spec, "rp-tl--ref");
        pvRef.textContent = "";
        pvRef.hidden = true;
        return;
      }
      clear(pvScrText);
      pvScrText.textContent = own ? "Your chosen scripture prints here" : scr.text;
      pvRef.textContent = own ? "From your notes" : scr.ref;
      pvRef.hidden = false;
    }
    // Template lines never re-wrap: if the longest one is wider than the space,
    // the whole message or scripture is set a little smaller, as a designer would.
    function fitTemplate(box, space) {
      if (!box.classList.contains("is-template") || !box.getClientRects().length) return;
      var avail = space.getBoundingClientRect().width, fitTo = 1;
      function widest() {
        var w = 0;
        each(box.children, function (line) { w = Math.max(w, line.getBoundingClientRect().width); });
        return w;
      }
      box.style.setProperty("--tpl-fit", "1");
      // Text doesn't shrink exactly in proportion, so check again after each step.
      for (var i = 0, w = widest(); avail && w > avail - 1 && i < 8; i++, w = widest()) {
        fitTo = Math.floor(fitTo * (avail - 2) / w * 1000) / 1000;
        box.style.setProperty("--tpl-fit", String(fitTo));
      }
    }
    // The customer's sign-off goes where the template's closing line was:
    // its first line --tpl-gap message-lines below the message's last line,
    // baseline to baseline. Set in the sign-off's own em, so it shrinks
    // along with everything else when a long message is set smaller.
    function baseline(node) {
      var probe = el("span", "");
      probe.style.cssText = "display:inline-block;width:0;height:0;vertical-align:baseline";
      node.insertBefore(probe, node.firstChild);
      var y = probe.getBoundingClientRect().top;
      node.removeChild(probe);
      return y;
    }
    function placeSignOff() {
      pvOwn.classList.remove("is-signoff");
      pvOwn.style.removeProperty("--own-mt");
      var last = pvMsg.lastElementChild;
      if (pvOwn.hidden || pvMsg.hidden || !last || !pvMsg.classList.contains("is-template")) return;
      var tplFs = parseFloat(getComputedStyle(last).fontSize);
      var ownFs = parseFloat(getComputedStyle(pvOwn).fontSize);
      var zoom = pvMsg.getBoundingClientRect().width / (pvMsg.offsetWidth || 1) || 1;
      if (!tplFs || !ownFs) return;
      var gap = parseFloat(pvMsg.style.getPropertyValue("--tpl-gap")) || TPL_DEFAULTS.gap;
      var now = (baseline(pvOwn) - baseline(last)) / zoom;
      pvOwn.style.setProperty("--own-mt", ((gap * tplFs - now) / ownFs).toFixed(3) + "em");
      pvOwn.classList.add("is-signoff");
    }

    function renderPreview() {
      var scr = picked(scrSel);
      var std = pickedMsg();
      var mine = msg ? msg.value.trim() : "";
      var n = names ? names.value.trim() : "";

      // Scripture: just above the fold (tall-sheet cards) or bottom left (book cards).
      // A scripture of the customer's choice shows as a faint stand-in.
      var own = ownScr();
      var scrOn = !!scr.text || own;
      pvScr.hidden = !scrOn;
      pvScr.classList.toggle("is-placeholder", own);
      renderScripture(scr, own);
      setLettering(pvScr, lettering("scr"));
      if (scrTip) scrTip.hidden = !own;
      if (extra) extra.setAttribute("placeholder", own
        ? "For example: Moroni 7:47 for the scripture. Anything else, like a QR code or an invitation, goes here too."
        : extraPlaceholder);

      // Message side: message, own words, names, signature
      renderStdMsg(std);
      pvMsg.hidden = !std;
      pvOwn.textContent = mine;
      pvOwn.hidden = !mine;
      // A message printed inside the card (cfg.preprinted) keeps its script
      // lettering; the customer's choice is for their personal message.
      setLettering(pvMsg, cfg.preprinted ? "ff-script" : lettering("msg"));
      setLettering(pvOwn, lettering("msg"));
      setLettering(pvNames, lettering("names"));

      var signed = isSigned();
      var isPdf = pvSig.hasAttribute("data-rp-pdf");
      var isPage = pvSig.hasAttribute("data-rp-page");
      var hasImg = !!pvSig.getAttribute("src") && !isPdf && !isPage;
      var anyWords = !!(std || mine || n);

      // Names: List Layout, or Tree Layout with room to sign above each one.
      var spaced = namesLayout() === "spaced" && !!n;
      var lined = !spaced && signed && !!n;
      pvNames.classList.toggle("is-spaced", spaced);
      pvNames.classList.toggle("is-signed", lined);
      var people = 0;
      if (spaced) {
        people = renderSignBlocks(pvNames, n, {
          signed: signed,
          set: signed && hasFile(),
          img: signed && hasImg ? pvSig.src : ""
        });
      } else if (lined) {
        people = renderSignedNames(pvNames, n, { set: hasFile(), img: hasImg ? pvSig.src : "" });
      } else {
        renderNames(pvNames, n);
      }
      pvNames.hidden = !n;
      if (pvSigWrap) pvSigWrap.hidden = spaced || lined;
      if (spaceNote) {
        spaceNote.hidden = !(spaced || lined);
        if (lined) {
          spaceNote.textContent = people > 1
            ? "Each signature prints on the dotted line above its name, in the same order as the names. The lines themselves don't print."
            : "Your signature prints on the dotted line above your name. The line itself doesn't print.";
        } else {
          spaceNote.textContent = signed
            ? (people > 1
              ? "Each signature prints in its dotted box, in the same order as the names. The boxes themselves don't print."
              : "Your signature prints in the dotted box. The box itself doesn't print.")
            : "The dotted boxes show the space left for signing. They don't print.";
        }
      }
      if (namesTip) {
        var one = nameLines(n);
        namesTip.hidden = !(namesLayout() === "spaced" && one.length === 1 && (one[0].match(/[,;]/g) || []).length >= 2);
      }

      pvSig.hidden = !(signed && hasImg);
      // Keep the card truly blank until the customer adds something. Hand-Signed
      // cards show nothing here: they sign by hand under the names.
      pvSigPh.hidden = !signed || hasImg || !(anyWords || hasFile());
      var phText = "Your signature prints here";
      if (hasFile() && isPdf) phText = "Your signature (PDF) prints here";
      else if (hasFile() && isPage) phText = "Signatures from your photo print here";
      pvSigPh.textContent = phText;
      pvSigPh.classList.toggle("is-set", signed && hasFile());
      hint.hidden = !!(scrOn || anyWords || (signed && hasFile()));

      if (extraNote) extraNote.hidden = !(extra && extra.value.trim());

      // Dim a lettering picker while its part of the card is empty.
      var partScr = q('[data-rp-part="scr"]'), partMsg = q('[data-rp-part="msg"]'), partNames = q('[data-rp-part="names"]');
      if (partScr) partScr.classList.toggle("is-idle", !scrOn);
      if (partMsg) partMsg.classList.toggle("is-idle", !(std || mine));
      if (partNames) partNames.classList.toggle("is-idle", !n);

      // Same wording the old form used, so orders read the way you're used to.
      var opt;
      if (std && mine) opt = "Standard plus Custom Message";
      else if (std) opt = "Standard Message";
      else if (mine) opt = "Custom Message";
      else if (scrOn) opt = "Scripture only";
      else opt = "Blank Card";
      if (msgOpt) msgOpt.value = opt;

      if (count && msg) {
        var len = msg.value.length;
        count.textContent = len ? len + " characters" : "";
      }
      fit();
    }

    // Shrink text until it fits its part of the card.
    function fitBox(box, zone, prop) {
      var scale = 1;
      card.style.setProperty(prop, "1");
      var avail = zone.clientHeight;
      if (!avail || box.hidden) return { scale: 1, over: false };
      // Too tall for its space, or a name too wide to fit on one line.
      function over() {
        return box.offsetHeight > avail + 1 || box.scrollWidth > box.clientWidth + 1;
      }
      while (over() && scale > MIN_SCALE) {
        scale = Math.round((scale - 0.04) * 100) / 100;
        card.style.setProperty(prop, String(scale));
      }
      return { scale: scale, over: over() };
    }
    function fit() {
      card.style.setProperty("--rp-scale", "1");
      card.style.setProperty("--rp-scr-scale", "1");
      fitTemplate(pvMsg, pvMsg);
      fitTemplate(pvScrText, pvScr);
      placeSignOff();
      fitBox(pvScr, zoneScr, "--rp-scr-scale");
      var r = fitBox(stack, zoneMsg, "--rp-scale");
      state.overflow = r.over;
      if (r.over) {
        fitNote.textContent = "This is too long to fit on the card. Please shorten your message or names.";
        fitNote.hidden = false;
      } else if (r.scale < SMALL_SCALE) {
        fitNote.textContent = "Your message is on the long side, so we'll print it a little smaller, as shown.";
        fitNote.hidden = false;
      } else {
        fitNote.hidden = true;
      }
    }

    /* ---------- enlarge ---------- */
    // The enlarged card is moved to the end of the page body while it's open.
    // Inside the product section, a theme's sticky header or banner can sit on
    // top of it no matter how high its z-index is; at body level nothing can.
    var stageHome = document.createComment("rp-stage");
    var portal = null;
    function movePortal(on) {
      if (on && !portal) {
        portal = document.createElement("div");
        portal.className = "rp rp-preview rp-portal is-zoomed";
        stage.parentNode.insertBefore(stageHome, stage);
        portal.appendChild(stage);
        document.body.appendChild(portal);
      } else if (!on && portal) {
        stageHome.parentNode.insertBefore(stage, stageHome);
        stageHome.parentNode.removeChild(stageHome);
        portal.parentNode.removeChild(portal);
        portal = null;
      }
    }
    function setZoom(on) {
      movePortal(on);
      preview.classList.toggle("is-zoomed", on);
      document.documentElement.classList.toggle("rp-noscroll", on);
      if (on) { zoomClose.focus({ preventScroll: true }); } else { zoomBtn.focus({ preventScroll: true }); }
      requestAnimationFrame(function () {
        fit();
        if (!on) return;
        // Open centred on the fold, where the scripture and message are.
        stage.scrollLeft = Math.max(0, (stage.scrollWidth - stage.clientWidth) / 2);
        var foldY = card.offsetTop + card.offsetHeight / 2;
        stage.scrollTop = Math.max(0, foldY - stage.clientHeight / 2);
      });
    }
    if (zoomBtn && zoomClose) {
      zoomBtn.addEventListener("click", function () { setZoom(true); });
      zoomClose.addEventListener("click", function () { setZoom(false); });
      stage.addEventListener("click", function (e) {
        if (e.target === stage && preview.classList.contains("is-zoomed")) setZoom(false);
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && preview.classList.contains("is-zoomed")) setZoom(false);
      });
    }

    /* ---------- pricing ---------- */
    function renderTotals() {
      var n = packs();
      var signed = isSigned() && cfg.sigVariantId;
      var packsTotal = n * cfg.price;
      var sigTotal = signed ? n * cfg.sigPrice : 0;
      var saving = 0;
      var bulkOn = cfg.bulkMin > 0 && cfg.bulkPrice > 0 && cfg.bulkPrice < cfg.price;

      if (bulkOn && n >= cfg.bulkMin) saving = n * (cfg.price - cfg.bulkPrice);

      q("[data-rp-row-packs]").textContent = n + (n === 1 ? " pack × " : " packs × ") + money(cfg.price);
      q("[data-rp-amt-packs]").textContent = money(packsTotal);

      var sigRow = q("[data-rp-row-sig]");
      sigRow.hidden = !signed;
      if (signed) {
        q("[data-rp-lbl-sig]").textContent = "Printed signature × " + n;
        q("[data-rp-amt-sig]").textContent = money(sigTotal);
      }

      var bulkRow = q("[data-rp-row-bulk]");
      bulkRow.hidden = !saving;
      if (saving) {
        q("[data-rp-lbl-bulk]").textContent = "Ward & bulk price, " + money(cfg.bulkPrice) + " a pack";
        q("[data-rp-amt-bulk]").textContent = "−" + money(saving);
      }

      var total = packsTotal + sigTotal - saving;
      q("[data-rp-total]").textContent = money(total);
      if (cfg.available) submit.textContent = "Add to cart · " + money(total);

      if (cards) cards.textContent = (n * cfg.pack).toLocaleString() + " cards";

      if (bulk) {
        if (!bulkOn) {
          bulk.hidden = true;
        } else if (n >= cfg.bulkMin) {
          bulk.hidden = false;
          bulk.textContent = "Ward & bulk price applied: you save " + money(saving) + ". It shows at checkout.";
        } else if (cfg.bulkMin - n <= 4) {
          var more = cfg.bulkMin - n;
          bulk.hidden = false;
          bulk.textContent = "Add " + more + " more pack" + (more === 1 ? "" : "s") + " and pay " + money(cfg.bulkPrice) +
            " a pack. You'd save " + money(cfg.bulkMin * (cfg.price - cfg.bulkPrice)) + ".";
        } else {
          bulk.hidden = false;
          bulk.textContent = "Ordering for a ward? " + cfg.bulkMin + " or more packs are " + money(cfg.bulkPrice) + " a pack.";
        }
      }
    }

    /* ---------- combinations we don't print ---------- */
    // With Send in Signatures, names can't be in Script (it clashes with the
    // signatures), and on book-style cards they can't be listed together
    // (there's no room). Those buttons are greyed out with the reason shown,
    // and whatever they replaced comes back when the customer picks Hand-Signed.
    var forced = { font: null, layout: null };
    function setOff(input, off) {
      if (!input) return;
      input.disabled = off;
      var label = input.closest("label");
      if (label) {
        label.classList.toggle("is-off", off);
        if (off) label.title = "Not available with Send in Signatures";
        else label.removeAttribute("title");
      }
    }
    function applyRules() {
      var signed = isSigned();
      var script = q('[data-rp-ff="names"][data-ff="script"]');
      var serif = q('[data-rp-ff="names"][data-ff="modern"]');
      if (script && serif) {
        if (signed) {
          if (script.checked) { forced.font = "script"; serif.checked = true; }
          setOff(script, true);
        } else {
          setOff(script, false);
          if (forced.font && serif.checked) script.checked = true;
          forced.font = null;
        }
      }
      if (ruleFont) ruleFont.hidden = !signed;

      var together = q('[data-rp-nlayout="together"]');
      var spacedOpt = q('[data-rp-nlayout="spaced"]');
      var lockLayout = signed && cfg.layout === "vertical";
      if (together && spacedOpt) {
        if (lockLayout) {
          if (together.checked) { forced.layout = "together"; spacedOpt.checked = true; }
          setOff(together, true);
        } else {
          setOff(together, false);
          if (forced.layout && spacedOpt.checked) together.checked = true;
          forced.layout = null;
        }
      }
      if (ruleLayout) ruleLayout.hidden = !lockLayout;
      syncOn("[data-rp-ff]");
      syncOn("[data-rp-nlayout]");
    }

    /* ---------- state changes ---------- */
    function applyChoice() {
      var signed = isSigned();
      applyRules();
      syncOn("[data-rp-choice]");
      if (sigField) sigField.hidden = !signed;
      if (sigInput) sigInput.disabled = !signed;
      renderPreview();
      renderTotals();
    }

    function touched() {
      state.touched = true;
      updatePill();
    }

    each(qa("[data-rp-choice]"), function (r) { r.addEventListener("change", function () { clearError(); applyChoice(); }); });
    [scrSel, msgSel].forEach(function (sel) {
      if (sel) sel.addEventListener("change", function () {
        clearError(); syncOn("[data-rp-message] input"); renderPreview(); touched();
      });
    });
    each(qa("[data-rp-ff]"), function (r) {
      r.addEventListener("change", function () {
        if (r.getAttribute("data-rp-ff") === "names") state.namesFontPicked = true;
        syncOn("[data-rp-ff]"); renderPreview(); touched();
      });
    });
    // Names under signing space read best in plain Modern lettering (like your
    // samples), so switch to it unless the customer already chose lettering.
    function pickNamesFont(ff) {
      var r = root.querySelector('[data-rp-ff="names"][data-ff="' + ff + '"]');
      if (r && !r.disabled) r.checked = true;
    }
    each(qa("[data-rp-nlayout]"), function (r) {
      r.addEventListener("change", function () {
        var want = namesLayout() === "spaced" ? "modern" : "script";
        if (!state.namesFontPicked) {
          pickNamesFont(want);
          // With Send in Signatures, remember what Hand-Signed would have shown.
          if (isSigned()) forced.font = want === "script" ? "script" : null;
        }
        syncOn("[data-rp-nlayout]"); syncOn("[data-rp-ff]"); renderPreview(); touched();
      });
    });
    if (msg) msg.addEventListener("input", function () { renderPreview(); touched(); });
    if (names) names.addEventListener("input", function () { renderPreview(); touched(); });
    if (extra) extra.addEventListener("input", function () {
      if (extraNote) extraNote.hidden = !extra.value.trim();
      if (extra.value.trim() && errorBox.textContent.indexOf("which scripture") > -1) clearError();
    });

    if (sigInput) {
      sigInput.addEventListener("change", function () {
        clearError();
        var f = sigInput.files && sigInput.files[0];
        var wrap = sigInput.closest(".rp-file");
        pvSig.removeAttribute("src");
        pvSig.removeAttribute("data-rp-pdf");
        pvSig.removeAttribute("data-rp-page");
        if (!f) {
          fileName.textContent = "No file chosen";
          wrap.classList.remove("has-file");
          renderPreview();
          return;
        }
        if (f.size > MAX_FILE_MB * 1024 * 1024) {
          sigInput.value = "";
          fileName.textContent = "No file chosen";
          wrap.classList.remove("has-file");
          showError("That file is over " + MAX_FILE_MB + " MB. Please upload a smaller photo.", sigInput);
          renderPreview();
          return;
        }
        fileName.textContent = f.name;
        wrap.classList.add("has-file");
        if (/^image\//.test(f.type)) {
          var reader = new FileReader();
          reader.onload = function (e) {
            pvSig.onload = function () {
              // A tall photo is usually a whole page of signatures, which would
              // show as an unreadable thumbnail. Show a label instead; we trim
              // the signatures from it by hand.
              if (pvSig.naturalHeight > pvSig.naturalWidth * 0.8) pvSig.setAttribute("data-rp-page", "1");
              renderPreview();
            };
            pvSig.src = e.target.result;
          };
          reader.readAsDataURL(f);
        } else {
          pvSig.setAttribute("data-rp-pdf", "1");
          renderPreview();
        }
        touched();
      });
    }

    each(qa("[data-rp-qty-step]"), function (b) {
      b.addEventListener("click", function () {
        qty.value = Math.max(1, Math.min(999, packs() + parseInt(b.getAttribute("data-rp-qty-step"), 10)));
        renderTotals();
      });
    });
    qty.addEventListener("input", renderTotals);
    qty.addEventListener("blur", function () { qty.value = packs(); renderTotals(); });

    confirm.addEventListener("change", function () {
      var holder = confirm.closest(".rp-check");
      if (confirm.checked && holder) holder.classList.remove("is-missing");
      if (confirm.checked && errorBox.textContent.indexOf("preview") > -1) clearError();
    });

    /* ---------- "see it on your card" pill ---------- */
    function updatePill() {
      if (!pill) return;
      pill.hidden = !(state.touched && !state.cardVisible && state.formVisible && !state.ctaVisible);
    }
    if (pill && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        state.cardVisible = entries[0].isIntersecting;
        updatePill();
      }, { threshold: 0.35 }).observe(card);
      new IntersectionObserver(function (entries) {
        state.formVisible = entries[0].isIntersecting;
        updatePill();
      }).observe(form);
      new IntersectionObserver(function (entries) {
        state.ctaVisible = entries[0].isIntersecting;
        updatePill();
      }, { rootMargin: "0px 0px 80px 0px" }).observe(submit);
      pill.addEventListener("click", function () {
        card.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }

    /* ---------- add to cart ---------- */
    function validate() {
      if (state.overflow) return ["Your message is too long to fit on the card. Please shorten it.", msg || names];
      if (isSigned() && sigInput && !hasFile()) {
        return ["Please upload a photo of your signatures, or choose Hand-Signed to sign the cards yourself.", sigInput];
      }
      if (ownScr() && !(extra && extra.value.trim())) {
        return ["Please tell us which scripture you'd like in Special requests/notes.", extra];
      }
      if (!confirm.checked) return ["Please check the preview and check the box to confirm it's right.", confirm];
      return null;
    }

    function setBusy(on) {
      submit.disabled = on;
      submit.classList.toggle("is-busy", on);
      if (on) submit.textContent = "Adding to cart…";
      else renderTotals();
    }

    function readJson(res) {
      return res.text().then(function (t) {
        var data = {};
        try { data = t ? JSON.parse(t) : {}; } catch (e) { data = {}; }
        if (!res.ok) {
          var why = data.description || data.message || "Something went wrong adding this to your cart.";
          throw new Error(typeof why === "string" ? why : "Something went wrong adding this to your cart.");
        }
        return data;
      });
    }

    function previewFileName() {
      var code = String(cfg.productTitle || "").split(" ")[0].replace(/[^A-Za-z0-9-]/g, "");
      return "card-preview" + (code ? "-" + code : "") + ".png";
    }
    function previewPicture(signed) {
      var cap = window.RamahPreviewCapture;
      if (!cap || typeof cap.capture !== "function") return Promise.resolve(null);
      var when = "";
      try {
        when = new Date().toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
      } catch (e) { when = new Date().toString(); }
      var lines = [
        String(cfg.productTitle || "Card") + " · " + (signed ? "Send in Signatures" : "Hand-Signed"),
        "The preview as the customer saw it when they added it to the cart · " + when
      ];
      return new Promise(function (resolve) {
        var done = false;
        function finish(v) { if (!done) { done = true; resolve(v || null); } }
        setTimeout(function () { finish(null); }, 5000);
        try { cap.capture(card, lines).then(finish, function () { finish(null); }); } catch (e) { finish(null); }
      });
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      clearError();
      var problem = validate();
      if (problem) { showError(problem[0], problem[1]); return; }

      var n = packs();
      qty.value = n;
      var fd = new FormData(form);

      // Leave out empty optional fields so the order only shows what the customer filled in.
      var empty = [];
      fd.forEach(function (v, k) {
        if (typeof v === "string" ? v.trim() === "" : (v && v.size === 0 && !v.name)) empty.push(k);
      });
      empty.forEach(function (k) { fd.delete(k); });
      // Lettering only matters for parts that print.
      if (!scrChosen()) fd.delete("properties[Scripture lettering]");
      if ((cfg.preprinted || !pickedMsg()) && !(msg && msg.value.trim())) fd.delete("properties[Message lettering]");
      if (!(names && names.value.trim())) {
        fd.delete("properties[Names lettering]");
        fd.delete("properties[Names layout]");
      }

      var signed = isSigned() && cfg.sigVariantId;
      setBusy(true);

      // A picture of the preview goes on the order as "Card preview", so you
      // can see exactly what the customer saw. If it can't be made in time,
      // the order goes ahead without it.
      previewPicture(signed)
        .then(function (pic) {
          if (pic) fd.append("properties[Card preview]", pic, previewFileName());
          return fetch(cfg.cartAddUrl, {
            method: "POST",
            body: fd,
            headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
            credentials: "same-origin"
          });
        })
        .then(readJson)
        .then(function () {
          if (!signed) return null;
          return fetch(cfg.cartAddUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({
              items: [{ id: cfg.sigVariantId, quantity: n, properties: { "For": cfg.productTitle } }]
            })
          }).then(readJson).catch(function () {
            throw new Error("Your cards are in the cart, but the printed signature charge didn't add. " +
              "Please open your cart and try again, or contact us and we'll sort it out.");
          });
        })
        .then(function () {
          window.location.href = cfg.cartUrl;
        })
        .catch(function (err) {
          setBusy(false);
          showError(err.message || "Something went wrong adding this to your cart. Please try again.");
        });
    });

    /* ---------- first paint ---------- */
    // The page may open with Send in Signatures already applied to the names;
    // Hand-Signed would have shown Script, listed together.
    if (isSigned()) {
      forced.font = "script";
      if (cfg.layout === "vertical") forced.layout = "together";
    }
    syncOn("[data-rp-ff]");
    syncOn("[data-rp-nlayout]");
    syncOn("[data-rp-message] input");
    applyChoice();
    if (!cfg.available) submit.disabled = true;

    window.addEventListener("resize", fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  function boot() { each(document.querySelectorAll("[data-rp]"), init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();